import React from 'react';
import isUndefined from 'lodash/isUndefined';
export const LazyLoader = ({ component, initialFallback = React.createElement(React.Fragment, null), }) => {
    const fallback = React.useRef(() => initialFallback);
    const Component = component;
    const updateFallback = async () => {
        const result = await component._result;
        if (!isUndefined(result)) {
            fallback.current = result.default;
        }
    };
    React.useEffect(() => {
        updateFallback();
    }, [component]);
    return (React.createElement(React.Suspense, { fallback: React.createElement(fallback.current, null) },
        React.createElement(Component, null)));
};
